// src/features/policyDetail/policyDetailSlice.js
/* eslint-disable no-unused-vars */
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance,{ axiosInstance9000 } from "../../api/axiosInstance";

export const fetchPolicyDetail = createAsyncThunk(
  'policyDetail/fetchPolicyDetail',
  async (ano, { rejectWithValue }) => {
    try {
      const response = await axiosInstance9000.get(`/api/branch/claim/detail?ano=${ano}`);
      return response.data.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const policyDetailSlice = createSlice({
  name: 'policyDetail',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPolicyDetail.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchPolicyDetail.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchPolicyDetail.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default policyDetailSlice.reducer;
